const zh = {
  nav: {
    home: '首页',
    about: '关于我们',
    category: '分类',
    article: '文章',
  },
  home: {
    heroTitle: '性福宝导航',
    heroSubtitle: '精选成人资源一站式导航平台',
    heroDesc: '汇聚海量精选成人内容、娱乐资源及相关服务链接，分类清晰、更新及时、安全可靠',
    browseVideo: '浏览视频平台',
    learnMore: '了解更多',
    statSites: '精选站点',
    statCategories: '分类频道',
    statUptime: '服务可用率',
  },
  footer: {
    description: '精选成人资源一站式导航平台，分类清晰、更新及时、安全可靠，帮助您快速找到所需内容。',
    hotCategories: '热门分类',
    quickLinks: '常用链接',
    disclaimer: '免责声明',
    disclaimerText: '本站仅为导航收录平台，所收录网站内容与本站无关。访问者需自行判断内容合法性并承担相应责任。',
    copyright: '保留所有权利',
    terms: '用户协议',
    privacy: '隐私政策',
  },
  category: {
    allSites: '共收录',
    sitesUnit: '个站点',
    empty: '该分类下暂无收录站点',
    notFound: '分类未找到',
    notFoundDesc: '请检查分类地址是否正确',
    backHome: '返回首页',
  },
  article: {
    notFound: '文章未找到',
    notFoundDesc: '该文章可能已被移除或地址有误',
    readMore: '阅读全文',
    minRead: '阅读',
    relatedArticles: '相关文章推荐',
  },
  about: {
    breadcrumb: '关于我们',
    title: '关于性福宝导航',
    brandStory: '品牌故事',
    brandSubtitle: '始于2024年，专注成人资源导航',
    brandP1: '性福宝导航创立于2024年，是专为成人用户打造的一站式资源导航平台。我们的团队深知用户在浩瀚网络中寻找优质资源的困难，因此致力于通过精心筛选和系统分类，为用户提供高效、便捷的导航服务。',
    brandP2: '我们的编辑团队每天对收录的站点进行审核和更新，确保每一个链接都有效可用。从视频平台到直播互动，从图片图库到小说文学，从动漫漫画到社区论坛——我们覆盖了成人娱乐的全方位需求。',
    brandP3: '平台始终坚持「分类清晰、更新及时、安全可靠」的核心理念，目前已收录超过160个精选站点，涵盖8大分类频道，服务了数以万计的用户。我们相信，好的导航工具能够让用户告别繁琐搜索，畅享便捷的在线体验。',
    whyUs: '为什么选择我们',
    contactUs: '联系我们',
    email: '电子邮箱',
    workHours: '工作时间',
    workHoursValue: '周一至周五 9:00 - 18:00',
    feedback: '反馈建议',
    feedbackDesc: '欢迎通过右侧表单提交您的反馈或站点收录申请',
    sendMessage: '发送消息',
    sending: '发送中...',
    successMsg: '消息已发送成功，我们会尽快回复您！',
    nameLabel: '您的称呼',
    namePlaceholder: '请输入您的称呼',
    emailLabel: '电子邮箱',
    emailPlaceholder: '请输入您的邮箱',
    subjectLabel: '主题',
    subjectPlaceholder: '请选择或输入主题',
    messageLabel: '消息内容',
    messagePlaceholder: '请输入您的消息内容（最多500字）',
  },
};

export default zh;